import messageAlert from "./message-alert";
import messageLandscape from './message-landscape';

import isMobile from '../util/isMobile';

messageAlert();
isMobile() && messageLandscape();